import React, {
  // Component,
  useState, useEffect} from 'react'
import Select from 'react-select'

const baseUrl = `${window.location.origin}/wp-json/wp/v2`;


const getStartups = params => {
  const dateTime = new Date().getTime();
  const timestamp = Math.floor(dateTime / 1000);
  const {per_page = 12, page = 1, order = null , orderby = 'title', cat_startup = null} = params
  let query = `${baseUrl}/startup?per_page=${per_page}&page=${page}`
  if(orderby) {
    query = `${query}&orderby=${orderby}`
  }
  if(order) {
    query = `${query}&order=${order}`
  }
  if(cat_startup) {
    query = `${query}&cat_startup=${cat_startup}`
  }
  query = `${query}&t=${timestamp}`
  return fetch(query).then(r => r.json())
}

const getCatStartup = () => {
  let query = `${baseUrl}/cat_startup/?lang=en&per_page=99`
  if(window.siteLang === 'it') query = `${baseUrl}/cat_startup/?lang=it&per_page=99`
  return fetch(query).then(r => r.json()).then(r => r.map(c => ({
    value : c.id,
    label : c.name,
  })))
}

const PostList = () => {
  const [posts, setPosts] = useState([])
  //eslint-disable-next-line
  const [per_page, setPerPage] = useState(100)
  //eslint-disable-next-line
  const [page, setPage] = useState(1)
  const [order, setOrder] = useState('desc')
  //eslint-disable-next-line
  const [orderby, setOrderBy] = useState('date')
  //eslint-disable-next-line
  const [cat_startup, setCatStartup] = useState(null)
  const [loading, setLoading] = useState(true)

  const [categoriesStartup, setCategoriesStartup] = useState([])

  // Starting number of visible blogs
  const [visibleBlogs, setVisibleBlogs] = useState(8)

  // Set the visible blogs to the current amount + 4
  // eg. if there are 10 visible post, clicking again will show 14.
  const handleClick = () => {
      setVisibleBlogs(prevVisibleBlogs => prevVisibleBlogs + 8)
  }

  const loadPosts = () => {
    setLoading(true)
    getStartups({ per_page, page, order, orderby, cat_startup })
    .then(r => {
      setPosts(r)
      setLoading(false)
    })
  }

  useEffect(loadPosts, [order, orderby, cat_startup])
  useEffect(() => {getCatStartup().then(r => setCategoriesStartup(r))},[])

  const handleOrder = e => {
    setOrder(e.value)
  }
  const handleOrderBy = e => {
    setOrderBy(e.value)
  }
  const handleOrderCat = e => {
    setCatStartup(e && e.value)
  }

  const optionsOrder = [
    { value: 'asc', label: window.siteLang === 'it' ? 'Ascendente': 'Ascending' },
    { value: 'desc', label: window.siteLang === 'it' ? 'Discendente': 'Descending' }
  ]

  const optionsOrderBy = [
    { value: 'title', label: window.siteLang === 'it' ? 'Titolo': 'Title' },
    { value: 'date', label: 'Data' }
  ]

  //const optionsOrderCat = [
  //  { value: '3', label: 'Startup1' },
  //  { value: '8', label: 'Settore2' }
  //]

  const SelectOrder = () => (
    <Select onChange={handleOrder} value={optionsOrder.filter(function(option) {return option.value === order;})} disabled={loading} options={optionsOrder} placeholder={window.siteLang === 'it' ? 'Ordinamento': 'Sort'} className={'custom-selector'}/>
  )

  const SelectOrderBy = () => (
    <Select onChange={handleOrderBy} value={optionsOrderBy.filter(function(option1) {return option1.value === orderby;})} disabled={loading} options={optionsOrderBy} placeholder={window.siteLang === 'it' ? 'Tipo di ordinamento': 'Order by'} className={'custom-selector'} />
  )

  const SelectOrderCat = () => (
    <Select isClearable={true} onChange={handleOrderCat} value={categoriesStartup.filter(function(option2) {return option2.value === cat_startup;})} disabled={loading} options={categoriesStartup} placeholder={window.siteLang === 'it' ? 'Settori': 'Sectors'} className={'custom-selector'}/>
  )

  const [searchInput, setSearchInput] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);

  const searchItems = (searchValue) => {
    setSearchInput(searchValue)
    if (searchInput !== '') {
        const filteredData = posts.filter((item) => {
            return Object.values(item.title.rendered).join('').toLowerCase().includes(searchInput.toLowerCase())
        })
        setFilteredResults(filteredData)
    }
    else{
        setFilteredResults(posts)
    }
  }


  return (
    <div>
      <div className="row-container-startup-sort">
        <div className="container-startup-sort">
          <div className="row-startup-sort">
            <div className="select-container search">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text"></span>
                </div>
                { window.siteLang === 'it'? 
                  <input type="text" className="form-control" placeholder='Cerca...'
                  onChange={(e) => searchItems(e.target.value)} />
                  :
                  <input type="text" className="form-control" placeholder='Search...'
                  onChange={(e) => searchItems(e.target.value)} />
                }
              </div>
            </div>
            <div className="row-select">
              <div className="select-container select-order-by">
                { window.siteLang === 'it'? <span>ordina per:</span>: <span>sort by:</span> }
                <SelectOrderBy/>
              </div>
              <div className="select-container select-order">
                { window.siteLang === 'it'? <span>ordinamento:</span>: <span>sort:</span> }
                <SelectOrder/>
              </div>
              <div className="select-container select-orderby">
                { window.siteLang === 'it'? <span>filtra per:</span>: <span>filter by:</span> }
                <SelectOrderCat/>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <div className="w-100 d-flex justify-content-center align-items-center p-5 loader"><i className="fa fa-spinner fa-pulse fa-4x fa-fw"></i></div>}
      <div className="container-startup">
        <div className="row row-startup">
            {searchInput.length > 1 ? (
              filteredResults.slice(0, visibleBlogs).map((item, index) => {
                      return (
                        <a key={index} className={`col-md-3 col-6 startup-card ${item.acf_fields.exit ? 'exit-startup' : '' }`} href={item.link}>
                        <article className={item.type} id={item.id}>
                          <div className="figure">
                            <img alt={item.title.rendered} src={item.fimg_url}/>
                            {item.acf_fields.exit && <div className="exit-badge">EXIT</div>}
                          </div>
                          <header className="entry-header text-left">
                            <h3>{item.title.rendered}</h3>
                            <div className="cat">{item.term_startup[0].name}</div>
                          </header>
                        </article>
                      </a>
                      )
                  })
              ) : (
              !loading && posts.slice(0, visibleBlogs).map((item, index) => (
                <a key={index} className={`col-md-3 col-6 startup-card ${item.acf_fields.exit ? 'exit-startup' : '' }`} href={item.link}>
                  <article className={item.type} id={item.id}>
                    <div className="figure">
                      <img alt={item.title.rendered} src={item.fimg_url}/>
                      {item.acf_fields.exit && <div className="exit-badge">EXIT</div>}
                    </div>
                    <header className="entry-header text-left">
                      <h3>{item.title.rendered}</h3>
                      <div className="cat">{item.term_startup[0].name}</div>
                    </header>
                  </article>
                </a>
              ))
            )}
            {searchInput.length > 1 ? (
              <>
                {visibleBlogs < filteredResults.length ? (
                  <div className='more-button'>
                    <button className="btn btn-danger" type="button" onClick={handleClick}>
                      { window.siteLang === 'it'? <>scopri di più</> : <>learn more</> }
                    </button>
                  </div>
                ) :('')}
              </>
            ) : (
              <>
                {visibleBlogs < posts.length ? (
                  <div className='more-button'>
                    <button className="btn btn-danger" type="button" onClick={handleClick}>
                      { window.siteLang === 'it'? <>scopri di più</> : <>learn more</> }
                    </button>
                  </div>
                ) :('')}
              </>
            )}
              
        </div>
      </div>
    </div>
  )
}
//
//
// class PostList extends Component {
//   constructor (props){
//      super(props);
//      this.state = {
//        posts: [],
//        params: {
//          page: 1,
//          per_page: 12,
//          order: null,
//          orderby: null,
//          cat_startup: null
//        }
//      }
//   }
//
//   componentDidMount() {
//     getStartups(this.state.params)
//       .then(r => {
//         this.setState({
//           posts: r,
//         })
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//  }
//
//  render() {
//    const { posts } = this.state
//
//    const setOrder = event => {
//      const { value } = event.target
//      if(value === '') {
//        this.setState({ params: { ...this.state.params, orderby: null, order: null } })
//      } else {
//       this.setState({ params: { ...this.state.params, orderby: 'title', order: value } })
//      }
//      getStartups(this.state.params)
//      .then(r => {
//        this.setState({
//          posts: r,
//        })
//      })
//      .catch((error) => {
//        console.error(error);
//      })
//    }
//
//    return (
//      <div>
//
//      <select onChange={setOrder.bind(this)}>
//          <option value="">All Champs</option>
//          <option value="asc">ASC</option>
//          <option value="desc">DESC</option>
//        </select>
//
//            {posts.map((item, index) => (
//            <div>
//              <div className="row">
//                <div className="leftcolumn">
//                  <div className="card">
//                    <div className= "title">
//                      <h1>{item.title.rendered}</h1>
//                    </div>
//                    <div className= "content" dangerouslySetInnerHTML={{ __html: item.content.rendered }} />
//                  </div>
//                </div>
//              </div>
//            </div>
//            ))}
//      </div>
//    )
//  }
// }

export default PostList;
